import { Routes } from '@angular/router';
import { OrgaoRelatoriosContent } from '@/features/registro/orgaos/relatorios/orgao-relatorios-content';
import { RelatorioFichaCadastral } from '@/features/registro/orgaos/relatorios/components/relatorio-ficha-cadastral/relatorio-ficha-cadastral';
import { RelatorioComposicao } from '@/features/registro/orgaos/relatorios/components/relatorio-composicao/relatorio-composicao';
import { ORGAO_ROUTES } from '@/features/registro/orgaos/orgao.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

export const orgaoRelatoriosRoutes: Routes = [
    {
        path: ORGAO_ROUTES.RELATORIOS.ROOT,
        component: OrgaoRelatoriosContent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Relatórios', permission: PERMISSOES.orgaos.relatorios.escopo },
        children: [
            { path: '', component: RelatorioFichaCadastral },
            { path: ORGAO_ROUTES.RELATORIOS.FICHA_CADASTRAL, component: RelatorioFichaCadastral, data: { breadcrumb: 'Ficha Cadastral' } },
            { path: ORGAO_ROUTES.RELATORIOS.COMPOSICAO, component: RelatorioComposicao, data: { breadcrumb: 'Composição' } }
        ]
    }
];
